<button type="button" (click)="themeService.toggleTheme()"
    class="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-primary/10 transition-all duration-300 group overflow-hidden"
    [title]="themeService.isDarkMode() ? 'Switch to Light Mode' : 'Switch to Dark Mode'">

    <div class="relative flex items-center justify-center w-6 h-6">
        <!-- Sun Icon -->
        <iconify-icon icon="solar:sun-bold-duotone" width="22" height="22"
            class="absolute block transition-all duration-500 ease-in-out text-amber-500 group-hover:rotate-45"
            [class.opacity-0]="themeService.isDarkMode()" [class.scale-0]="themeService.isDarkMode()"
            [class.rotate-90]="themeService.isDarkMode()">
        </iconify-icon>

        <!-- Moon Icon -->
        <iconify-icon icon="solar:moon-bold-duotone" width="22" height="22"
            class="absolute block transition-all duration-500 ease-in-out text-indigo-400 group-hover:-rotate-12"
            [class.opacity-0]="!themeService.isDarkMode()" [class.scale-0]="!themeService.isDarkMode()"
            [class.-rotate-90]="!themeService.isDarkMode()">
        </iconify-icon>
    </div>
</button>